var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTravel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.58786C2 3.60634 3.567 2 5.5 2C7.433 2 9 3.60634 9 5.58786C9 7.73184 7.02794 9.28198 5.80328 9.92467C5.61189 10.0251 5.38811 10.0251 5.19672 9.92467C3.97206 9.28198 2 7.73184 2 5.58786ZM5.5 7.04542C6.25172 7.04542 6.86111 6.41293 6.86111 5.63271C6.86111 4.85248 6.25172 4.21999 5.5 4.21999C4.74828 4.21999 4.13889 4.85248 4.13889 5.63271C4.13889 6.41293 4.74828 7.04542 5.5 7.04542Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 17.5879C15 15.6063 16.567 14 18.5 14C20.433 14 22 15.6063 22 17.5879C22 19.7318 20.0279 21.282 18.8033 21.9247C18.6119 22.0251 18.3881 22.0251 18.1967 21.9247C16.9721 21.282 15 19.7318 15 17.5879ZM18.5 19.0454C19.2517 19.0454 19.8611 18.4129 19.8611 17.6327C19.8611 16.8525 19.2517 16.22 18.5 16.22C17.7483 16.22 17.1389 16.8525 17.1389 17.6327C17.1389 18.4129 17.7483 19.0454 18.5 19.0454Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4.75C11.0858 4.75 10.75 5.08579 10.75 5.5C10.75 5.91421 11.0858 6.25 11.5 6.25H16.7967C17.0288 6.25 17.1357 6.53876 16.9594 6.68981L7.06432 15.1713C5.83075 16.2286 6.5785 18.25 8.20321 18.25H12.5C12.9142 18.25 13.25 17.9142 13.25 17.5C13.25 17.0858 12.9142 16.75 12.5 16.75H8.20321C7.97111 16.75 7.86429 16.4612 8.04051 16.3102L17.9356 7.8287C19.1692 6.77135 18.4215 4.75 16.7967 4.75H11.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTravel);
export default __webpack_public_path__ + "static/media/travel.0da33c153c6c65e7d3f9351b858d6eb9.svg";
export { ForwardRef as ReactComponent };